import MessageRenderer from "./MessageRenderer";

class MessageParser {
  constructor(actionProvider, state, createChatBotMessage) {
    this.actionProvider = actionProvider;
    this.state = state;
    this.createChatBotMessage = createChatBotMessage;
  }

  async parse(incomingMessage) {
    const inputElement = document.querySelector('.react-chatbot-kit-chat-input');
    if (!incomingMessage && !incomingMessage.trim() && !inputElement.value) {
      this.actionProvider.sendBotResponse("Please type a valid message.");
      return;
    }

    // Show typing indicator
    this.actionProvider.setIsTyping(true);
    localStorage.setItem('chatbot_typing','Typing');

    try {
      const response = await this.getReply(incomingMessage || inputElement.value);
      if (response) {
        this.actionProvider.sendBotResponse(response); // Send the JSX response
      } else {
        throw new Error("No response received from the backend.");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      // Hide typing indicator
      localStorage.setItem('chatbot_typing','');
      this.actionProvider.setIsTyping(false);
    }
  }

  extractContent(data, labelStart, labelEnd) {
    const regex = new RegExp(`#~${labelStart}~#(.*?)#~${labelEnd}~#`, "g");
    let match;
    const extractedData = [];
    // debugger
    while ((match = regex.exec(data)) !== null) {
      try {
        extractedData.push(JSON.parse(match[1]));
      } catch (e) {
        // console.log("Error parsing JSON:", e, match[1]);
        extractedData.push(match[1]);
      }
    }
    let output = extractedData[0];
    if (output && output instanceof Object) {
      // console.log("Extracted data: ", output);
      output = JSON.stringify(extractedData[0]);
    }

    // console.log("Extracted data: 2", output);
    return output || null;
  }

  async getReply(userMessage) {
    const userId = localStorage.getItem("user_id");
    const company = localStorage.getItem("company_name");
    setTimeout(()=>{
      const userChatCollection = document.getElementsByClassName('react-chatbot-kit-user-chat-message');
      const userChat = [...userChatCollection];
      userChat[userChat.length - 1].innerHTML =userMessage;
    },500)
    return new Promise((resolve, reject) => {
      const source = new EventSource(
        `${
          process.env.REACT_APP_API_URL
        }/process_question?user_id=${userId}&company=${encodeURIComponent(
          company
        )}&question=${encodeURIComponent(userMessage)}&pii_mode=${localStorage.getItem('pii')}&stream=true`
      );

      source.onmessage = (event) => {
        this.actionProvider.setIsTyping(false); // Hide typing indicator
        const rawData = event.data;
        if (rawData === "[DONE]") {
          source.close();
          resolve("--"); // Complete the stream
          return;
        }
        try {
          let tool = this.extractContent(rawData, "STC", "ETC");
          if (tool) {
            this.prevTool = tool;
          } else if (!tool && this.prevTool) {
            tool = this.prevTool;
          }

          const toolInput = this.extractContent(rawData, "STCI", "ETCI");
          const thought = this.extractContent(rawData, "STT", "ETT");
          const finalOutput = this.extractContent(rawData, "SFOC", "EFOC");
          let sqlQuery = this.extractContent(rawData, "STCI", "ETCI");
          if (sqlQuery) {
            this.prevSqlQuery = sqlQuery;
          } else if (!sqlQuery && this.prevSqlQuery) {
            sqlQuery = this.prevSqlQuery;
          }
          const sqlQueryResult = this.extractContent(rawData, "SSRC", "SSRC");

          if (sqlQueryResult) {
            debugger;
          }
          if((!tool || !toolInput) && !thought && !finalOutput){
            return;
          }
          // console.log("All streaming info: ", {tool,toolInput,thought,finalOutput,sqlQuery,sqlQueryResult});
          const messageRenderer = (
            <MessageRenderer
              userId={userId}
              tool={tool}
              toolInput={toolInput}
              thought={thought}
              finalOutput={finalOutput}
            />
          );
          this.actionProvider.sendBotResponse(messageRenderer);

          if (tool && toolInput) {
            this.prevTool = null;
          }
          if (sqlQuery && sqlQueryResult) {
            this.prevSqlQuery = null;
          }
        } catch (error) {
          console.error("Error parsing response:", error, rawData);
          this.actionProvider.sendBotResponse(
            "Error parsing response. Please check the data format."
          );
          source.close();
          reject(error);
        } finally {
          // Hide typing indicator when the first streaming message is arrived
          this.actionProvider.setIsTyping(false);
        }
      };

      source.onerror = (error) => {
        console.error("Streaming error:", error);
        source.close();
        reject(new Error("An error occurred while streaming the response."));
      };

      source.onopen = () => {
        // console.log("Connection opened for streaming.");
      };
    });
  }
}

export default MessageParser;
